<style>
.bg-primary {
  background-color: #2b4e8a !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader
      class="bg-primary text-white border-0 font-weight-bold p-3 d-flex align-items-center"
    >
      Kuesioner Pelatihan
      <!-- <CButton color="info" style="float:right;margin-right:10px" class="btn-md ml-auto">Print</CButton> -->
      <CButton
        color="danger"
        style="float:right;margin-right:10px"
        class="btn-md ml-auto"
      >Ekspor PDF</CButton>
      <CDropdown
        toggler-text="Ekspor Excel"
        color="warning"
        class="mr-2 d-inline-block text-white float-right"
      >
        <CDropdownItem>Ekspor Semua</CDropdownItem>
        <CDropdownItem>Ekspor Beberapa Data</CDropdownItem>
      </CDropdown>
    </CCardHeader>
    <!-- Tabs -->
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/pelatihan/kusioner"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          id="home-tab"
          data-toggle="tab"
          href="#home"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >Master Kuesioner</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/pelatihan/respon-kuesioner"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          id="profile-tab"
          data-toggle="tab"
          href="#profile"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >Respon Kuesioner</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/pelatihan/summary-kuesioner"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          style="background-color: #486ba7;"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >Summary Kuesioner</router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/pelatihan/statistik-kepuasan"
          class="nav-link p-3 px-5 font-weight-bold text-white"
          id="contact-tab"
          data-toggle="tab"
          href="#contact"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
        >Statistik Kuesioner</router-link>
      </li>
    </ul>
    <!-- Data Workshop -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12">
          <div class="form-group">
            <label for>Pilih Pelatihan</label>
            <select class="form-control" name id>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
      </CRow>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id>
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control" placeholder="Cari Data ..." />
          </div>
        </div>
      </CRow>
      <CRow class="mt-3">
        <label class="ml-3">
          <h4>
            <b>Kategori 1 (Sangat Baik,Baik,Cukup,Kurang)</b>
          </h4>
        </label>
        <CCol lg="12" class="table-responsive">
          <table class="table text-center table-striped">
            <thead>
              <tr>
                <th rowspan="2">No</th>
                <th rowspan="2">Kode Kuesioner</th>
                <th colspan="5" class="text-center">Jawaban</th>
                <th rowspan="2" class="text-center">Jumlah Responden</th>
              </tr>
              <tr>
                <th>Buruk</th>
                <th>Kurang</th>
                <th>Cukup</th>
                <th>Baik</th>
                <th>Sangat Baik</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td scope="row">1</td>
                <td>p-01</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
              <tr>
                <td scope="row">2</td>
                <td>p-02</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
              <tr>
                <td scope="row">3</td>
                <td>p-03</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
              <tr>
                <td scope="row">4</td>
                <td>p-04</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
              <tr>
                <td scope="row">5</td>
                <td>p-05</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
            </tbody>
          </table>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>

      <!-- Tabel Untuk Kusioner Kategori 2 -->

      <CRow class="mt-3">
        <label class="ml-3">
          <h4>
            <b>Kategori 2 (Ya,Tidak,Mungkin)</b>
          </h4>
        </label>
        <CCol lg="12" class="table-responsive">
          <table class="table text-center table-striped">
            <thead>
              <tr>
                <th rowspan="2">No</th>
                <th rowspan="2">Kode Kuesioner</th>
                <th colspan="5" class="text-center">Jawaban</th>
                <th rowspan="2" class="text-center">Jumlah Responden</th>
              </tr>
              <tr>
                <th colspan="2">Ya</th>
                <th colspan="2">Tidak</th>
                <th>Mungkin</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td scope="row">1</td>
                <td>p-01</td>
                <td colspan="2">0%</td>
                <td colspan="2">0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
              <tr>
                <td scope="row">2</td>
                <td>p-02</td>
                <td colspan="2">0%</td>
                <td colspan="2">0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
              <tr>
                <td scope="row">3</td>
                <td>p-03</td>
                <td colspan="2">0%</td>
                <td colspan="2">0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
              <tr>
                <td scope="row">4</td>
                <td>p-04</td>
                <td colspan="2">0%</td>
                <td colspan="2">0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
              <tr>
                <td scope="row">5</td>
                <td>p-05</td>
                <td colspan="2">0%</td>
                <td colspan="2">0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
            </tbody>
          </table>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>

      <!-- Kategori 4 untuk kusioner type medsos -->
      <CRow class="mt-3">
        <label class="ml-3">
          <h4>
            <b>Kategori 3 (Website,Instagram,Facebook,Twitter,Rekan Kerja)</b>
          </h4>
        </label>
        <CCol lg="12" class="table-responsive">
          <table class="table text-center table-striped">
            <thead>
              <tr>
                <th rowspan="2">No</th>
                <th rowspan="2">Kode Kuesioner</th>
                <th colspan="5" class="text-center">Jawaban</th>
                <th rowspan="2" class="text-center">Jumlah Responden</th>
              </tr>
              <tr>
                <th>Website</th>
                <th>Intagram</th>
                <th>Facebook</th>
                <th>Twitter</th>
                <th>Rekan Kerja</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td scope="row">1</td>
                <td>p-01</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
              <tr>
                <td scope="row">2</td>
                <td>p-02</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
              <tr>
                <td scope="row">3</td>
                <td>p-03</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
              <tr>
                <td scope="row">4</td>
                <td>p-04</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
              <tr>
                <td scope="row">5</td>
                <td>p-05</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0%</td>
                <td>0</td>
              </tr>
            </tbody>
          </table>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>

      <!-- Modal detail -->
      <CModal
        title="Modal title"
        :show.sync="myModalDetail"
        :no-close-on-backdrop="true"
        :centered="true"
        size="md"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body">
              <div class="d-block">
                <h5>Kode Kuesioner</h5>
                <p class="ml-3 text-muted">P-01</p>
              </div>
              <div class="d-block">
                <h5>Pertanyaan</h5>
                <p class="ml-3 text-muted">Bagaimana Kualitas Pelaksanaan Pelatihan ?</p>
              </div>
              <div class="d-block">
                <h5>Nama Pelatihan</h5>
                <p class="ml-3 text-muted">TAX REVIEW DAN PENYUSUNAN KERTAS KERJA</p>
              </div>
              <div class="d-block">
                <h5>Nama Responden</h5>
                <p class="ml-3 text-muted">Fachruddin Satya Al - Farobi Anwar</p>
              </div>
              <div class="d-block">
                <h5>Jawaban</h5>
                <p class="ml-3 text-muted">Buruk</p>
              </div>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail</h6>
        </template>
        <template #footer>
          <CButton @click="myModalDetail = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data provinsi -->
  </CCard>
</template>
<script>
const items = [
  {
    no: "1",
    kode_kuesioner: "P-01",
    kode_ppl: "PPL-01",
    nama_respon: "Fachrudin Satya Al-Farobi Anwar",
    jawaban: "Buruk",
    _status: 0
  },
  {
    no: "2",
    kode_kuesioner: "P-2",
    kode_ppl: "PPL-01",
    nama_respon: "Fachrudin Satya Al-Farobi Anwar",
    jawaban: "Buruk",
    _status: 0
  },
  {
    no: "3",
    kode_kuesioner: "P-3",
    kode_ppl: "PPL-01",
    nama_respon: "Fachrudin Satya Al-Farobi Anwar",
    jawaban: "Buruk",
    _status: 0
  },
  {
    no: "4",
    kode_kuesioner: "P-4",
    kode_ppl: "PPL-01",
    nama_respon: "Fachrudin Satya Al-Farobi Anwar",
    jawaban: "Buruk",
    _status: 0
  },
  {
    no: "5",
    kode_kuesioner: "P-5",
    kode_ppl: "PPL-01",
    nama_respon: "Fachrudin Satya Al-Farobi Anwar",
    jawaban: "Buruk",
    _status: 0
  }
];

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false
  },
  {
    key: "kode_kuesioner",
    label: "Kode Kuesioner",
    sorter: true,
    filter: false
  },
  {
    key: "kode_ppl",
    label: "Kode Pelatihan",
    sorter: true,
    filter: false
  },
  {
    key: "nama_respon",
    label: "Nama Responden",
    sorter: true,
    filter: false
  },
  {
    key: "jawaban",
    label: "Jawaban",
    sorter: true,
    filter: false
  },
  {
    key: "_status",
    _style: "text-align: center",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:20%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Master RPL",
  data() {
    return {
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      formData: {
        judul: "",
        file: ""
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      fileName: "Choose File...",
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  methods: {
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              }
            });
            Toast.fire({
              icon: "success",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    }
  }
};
</script>